import FooterLogo from '../../assets/logos/FooterLogo';
import Socials from '../../components/Socials';

const Footer = () => {
    return (
        <footer>
            <div className='container'>
                <FooterLogo />
                <Socials />
                <p>
                    All rights reserved. &copy; {new Date().getFullYear()} Unlimited
                    Network.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
